import React, { useState, useEffect } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const CarnivalFilterForm = ({ applyFilter, status = []}) => {
  const [filterFieldsData, setFilterFieldsData] = useState({});
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);
  const [minDate, setMinDate] = useState(null);

  const handleDateChange2 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      fromDate: dateString,
    });
    setMaxToDate(dateString);
  };
  const handleDateChange3 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      toDate: dateString,
    });
  };
  const handleDateHide2 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous3(true);
    }
  };

  const setMaxToDate = (val) => {
    if (val != 'Invalid date') {
      var dateParts = val.split("-");
      // month is 0-based, that's why we need dataParts[1] - 1
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      setMinDate(dateObject);
    } else {
        setMinDate(null);
    }
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        // console.log(filterFieldsData);
        applyFilter(filterFieldsData);
        filterFieldsData &&
          localStorage.setItem('applyFilter', JSON.stringify(filterFieldsData));
      }}
    >
        <ConstantInput
            label={localization.projectId}
            value={filterFieldsData.project_id}
            regex={Regex.text.test(filterFieldsData.project_id)}
            type="text"
            handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, project_id: val })
            }
        />

        <ConstantInput
            label={localization.projectName}
            value={filterFieldsData.project_name}
            regex={Regex.text.test(filterFieldsData.project_name)}
            type="text"
            handleChange={(val) =>
            setFilterFieldsData({ ...filterFieldsData, project_name: val })
            }
        />

      <DropDownInput
        label={localization.status}
        data={[
            { id: 1, name: 'Active' },
            { id: 2, name: 'Inactive' },
            { id: 3, name: 'Completed' },
            { id: 4, name: 'Hold' }
          ]}
        getValueById={filterFieldsData?.status}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, status: val.id })
        }
      />

    <fieldset>
        <h4>{localization.createdBetween}</h4>

        <FormGroup
        className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
        >
        <DatePickerInput
            onChange={handleDateChange2}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous2(true)}
            onHide={handleDateHide2}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            // maxDate={new Date()}
        />
        <label>{localization.fromDate}</label>
        </FormGroup>

        <FormGroup
        className={`date custom_date_picker ${isFocus3 ? "active-date" : ""}`}
        >
        <DatePickerInput
            onChange={handleDateChange3}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous3(true)}
            onHide={handleDateHide3}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            minDate={minDate}
            // maxDate={new Date()}
        />

        <label>{localization.toDate}</label>
        </FormGroup>
    </fieldset>

      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            localStorage.setItem('applyFilter', JSON.stringify({}));
            applyFilter({});
            localStorage.setItem('statusFilter', JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default CarnivalFilterForm;
